import { render } from "./LessonCatsTopic1FutureOwner.vue?vue&type=template&id=255fc107"
import script from "./LessonCatsTopic1FutureOwner.vue?vue&type=script&lang=js"
export * from "./LessonCatsTopic1FutureOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__